import { useQuery } from '@tanstack/react-query';
import { accounts } from '@/api/documents';

interface Props {
  value: string;
  onChange: (id: string) => void;
  placeholder?: string;
  // alembic 0261: фільтр балансові/забалансові. undefined=всі; false=лише
  // балансові; true=лише забалансові (клас 0). Окремий queryKey, щоб кеш
  // балансових і забалансових не змішувався.
  offBalance?: boolean;
}

/**
 * Простой селект из всех «постаемых» счетов плана HOZRASCHETNY.
 * 400+ опций; для следующей итерации стоит сделать комбобокс с поиском.
 */
export default function AccountSelect({ value, onChange, placeholder, offBalance }: Props) {
  const q = useQuery({
    queryKey: ['accounts', offBalance ?? 'all'],
    queryFn: () => accounts.list({ only_postable: true, off_balance: offBalance, limit: 600 }),
    staleTime: 60 * 60 * 1000,
  });

  return (
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{placeholder ?? '—'}</option>
      {q.data?.map((a) => (
        <option key={a.id} value={a.id}>
          {a.code} — {a.name}
        </option>
      ))}
    </select>
  );
}
